import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import PartnerName from '../formFields/PartnerName';
import LegalEntityName from '../formFields/LegalEntityName';
import HostHeader from '../formFields/HostHeader';

const PartnerGeneralPartner = ({ errors, touched, darkMode, isAddMode }) => {
    const formFields = (errors, touched) => {
        const fields = [
            <PartnerName
                key="partnerName"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                isAddMode={isAddMode}
            />,
            <LegalEntityName
                key="legalEntityName"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <HostHeader
                key="hostHeader"
                darkMode={darkMode}
                errors={errors}
                touched={touched}
            />,
        ];

        return fields;
    };

    const filteredFields = formFields(errors, touched).filter(Boolean);

    return (
        <AccordionItemHandler
            index={0}
            key="partnerGeneral"
            label="Partner Details"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {filteredFields}
        </AccordionItemHandler>
    );
};

export default PartnerGeneralPartner;
